import * as React from 'react';

import type { WESAskCourseraLauncherProps } from 'bundles/wes-common/components/WESAskCoursera/WESAskCourseraLauncherTypes';

import { FloatingWESAskCourseraLauncher } from './FloatingWESAskCourseraLauncher';
import WESAskCourseraHeaderLauncher from './WESAskCourseraHeaderLauncher';

const WESAskCourseraLauncher = ({
  launcherPlacement = 'floating',
  isOpen,
  onClick,
  ...floatingProps
}: WESAskCourseraLauncherProps) => {
  if (launcherPlacement === 'header') {
    return <WESAskCourseraHeaderLauncher isOpen={isOpen} onClick={onClick} />;
  }

  return <FloatingWESAskCourseraLauncher isOpen={isOpen} onClick={onClick} {...floatingProps} />;
};

export default WESAskCourseraLauncher;
